<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const REASON = 'get_deletion_reason.php'
	const ACT_INFO = 'get_act_info.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'reason',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		methods: {
			change () {
				EventBus.$emit(`edit_deletion_reason`, this.selected)
			}
		},
		created () {
			fetch(DB + ACT_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				return res[0].f_8
			})
			.then(id => {
				fetch(DB + REASON, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = data
						this.selected = id
					}
					else {
						this.options = []
						this.selected = '0'
					}
				})
				.catch(err => console.log(err))
			})
			.catch(err => console.log(err))	
		}
	}
</script>


// WEBPACK FOOTER //
// deletionReason.vue?fb9f11ce